import React from 'react';
import { PriorityLevel } from './types';
import ReviewTriggerPopup from '../Table/components/ReviewTriggerPopup';
import { ListGlass, PriorityUp, PriorityDown } from '../Icons';

import './styles.css';
import { usePopup } from '../../hooks';

interface PriorityProps {
  id: string;
  priority?: PriorityLevel;
}
const Priority = ({ id, priority = PriorityLevel.MEDIUM }: PriorityProps) => {
  const { openPopup, openPopupId, closePopup } = usePopup();
  const priorityIcon = React.useMemo(() => {
    switch (priority) {
      case PriorityLevel.HIGH:
        return <PriorityUp />;
      case PriorityLevel.LOW:
        return <PriorityDown />;
      default:
        return <></>;
    }
  }, []);
  return (
    <>
      <div
        className="d-flex position-relative clickable"
        onClick={(e) => {
          e.stopPropagation();
          openPopup(id);
        }}
      >
        <div className="priority-level-icon">{priorityIcon}</div>
        <ListGlass />
      </div>
      <ReviewTriggerPopup open={openPopupId === id} onHide={closePopup} />
    </>
  );
};

export default Priority;
